import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import reducer from './reducers';
import Form from './components/Form';
import Terms from './components/Terms';
import SummaryContainer from './components/SummaryContainer';
import styles from './index.scss';

class Checkout extends React.Component {
  store = createStore(reducer, this.props, applyMiddleware(thunk));

  render() {
    return (
      <Provider store={this.store}>
        <>
          <div className={styles.container}>
            <SummaryContainer />
            <Form />
          </div>
          <Terms />
        </>
      </Provider>
    );
  }
}

export default Checkout;
